import { Component, OnDestroy } from '@angular/core';
import { SignupWizardService } from '@app/modules/user/signup/signup-wizard.service';
import { BehaviorSubject, Subscription, timer } from 'rxjs';

@Component({
  standalone: false,
  selector: 'sbnb-signup-validate-phone',
  template: `
    <section class="sbnb-onboarding">
      <sbnb-signup-header></sbnb-signup-header>

      <article class="main">
        <header>
          <h2 class="mb-0">Verify your account</h2>
        </header>

        <section class="content">
          <p>
            We've sent a one time code to {{ wizard.signupUser.mobile_phone }}. Enter the code we've sent to continue.
            This code is valid for 10 minutes.
          </p>
          <sbnb-otp-input class="block mt-4" [size]="6" [(ngModel)]="otp"></sbnb-otp-input>

          <sbnb-button class="block mt-8" (clicked)="validateCode(otp)">Validate code</sbnb-button>

          <ng-container *ngIf="(codeRecentlyRequested$ | async) === false; else codeRecentlyRequestedTemplate">
            <span *ngIf="cooldownActive" class="block mt-10 text-sm">
              Didn't receive the code? You can request another in {{ cooldownTimeSeconds }} seconds.
            </span>
            <span *ngIf="!cooldownActive" class="block mt-10 text-sm">
              Didn't receive the code?
              <a
                class="inline-block ml-1 grass-darker cursor-pointer font-extrabold not-italic"
                (click)="requestNewCode()">
                Resend
              </a>
            </span>
          </ng-container>

          <ng-template #codeRecentlyRequestedTemplate>
            <span class="mt-10 text-sm grass-darker font-extrabold">A new code has been sent to your phone.</span>
          </ng-template>
        </section>
      </article>

      <aside>
        <img src="/assets/images/signup/password.svg" />
      </aside>
    </section>
  `,
  styleUrls: ['./signup-validate-phone.component.scss'],
})
export class SignupValidatePhoneComponent implements OnDestroy {
  private readonly COOLDOWN_DURATION_SECONDS = 30;

  cooldownTimeSeconds = this.COOLDOWN_DURATION_SECONDS;
  cooldownActive = false;
  cooldownSubscription: Subscription;
  codeRecentlyRequested$ = new BehaviorSubject<boolean>(false);

  otp = '';

  constructor(public wizard: SignupWizardService) {
    this.startCooldown();

    if (!this.wizard.signupUser.token) {
      this.wizard.cancel();
    }
  }

  ngOnDestroy() {
    if (this.cooldownSubscription) {
      this.cooldownSubscription.unsubscribe();
    }
  }

  validateCode(code: string) {
    this.wizard.validatePhoneWithOtp(code).subscribe({
      next: (res: boolean) => {
        if (res) {
          this.wizard.next();
        }
      },
    });
  }

  requestNewCode() {
    this.wizard.requestNewPhoneOtp().subscribe({
      next: (res: boolean) => {
        if (res) {
          this.setCodeRecentlyRequested();
        }
      },
    });
  }

  startCooldown() {
    this.cooldownActive = true;
    this.cooldownSubscription = timer(0, 1000).subscribe((seconds) => {
      this.cooldownTimeSeconds = this.COOLDOWN_DURATION_SECONDS - seconds;
      if (this.cooldownTimeSeconds <= 0) {
        this.cooldownSubscription.unsubscribe();
        this.cooldownActive = false;
      }
    });
  }

  setCodeRecentlyRequested() {
    this.codeRecentlyRequested$.next(true);

    timer(3000).subscribe(() => {
      this.codeRecentlyRequested$.next(false);
      this.startCooldown();
    });
  }
}
